import React from "react";
import { Form } from "react-bootstrap";
import { Controller, Control, FieldErrors, UseFormSetValue } from "react-hook-form";

interface BasedOnComponentProps {
    control: Control<any>;
    errors: FieldErrors<{
        filter: {
            property_id: string;
            base_on: string;
            start_date: string;
            end_date: string;
            room_type_id?: string;
        };
    }>;
    setValue: UseFormSetValue<any>;
    reportType: "sales_report" | "report_sales_monthly" | "report_agent" | "room_report" | "daily_report" | "country_report" | "report_reservation"; // <-- Tambah 'report_reservation'
}

const baseOnOptions: Record<"sales_report" | "report_sales_monthly" | "report_agent" | "room_report" | "daily_report" | "country_report" | "report_reservation", string[]> = {
    sales_report: ["stay_date", "created_reservation", "checkin_date", "checkout_date"],
    report_sales_monthly: ["created_reservation"],
    report_agent: ["stay_date", "created_reservation"],
    room_report: ["stay_date", "created_reservation"],
    daily_report: ["stay_date", "created_reservation"],
    country_report: ["created_reservation", "checkin_date"],
    report_reservation: ["created_reservation"], // <-- BARU: Pilihan untuk Laporan Tempahan
};

const BasedOnComponent: React.FC<BasedOnComponentProps> = ({ control, errors, setValue, reportType }) => {
    return (
        <div>
            <Form.Label className="me-2">Report Based On:</Form.Label>
            <Controller
                name="filter.base_on"
                control={control}
                rules={{ required: "Report Based On is required" }}
                render={({ field }) => (
                    <>
                        {baseOnOptions[reportType].map((option) => (
                            <Form.Check
                                key={option}
                                className="mt-2"
                                type="radio"
                                label={option.replace(/_/g, " ")}
                                value={option}
                                checked={field.value === option}
                                onChange={() => setValue("filter.base_on", option)}
                            />
                        ))}
                    </>
                )}
            />

            {errors.filter?.base_on && (
                <span className="text-danger">{errors.filter.base_on.message}</span>
            )}
        </div>
    );
};

export default BasedOnComponent;